module.exports = __webpack_public_path__ + "img/402.a1e41700.png";